// Các app code
export default {
  DbSystem: 'db-system',
  Salagov: 'salagov',
  SmartReport: 'smart-report',
  QLCB: 'qlcb',
  NEWSFEED: 'newsfeed',
  CONTACT: 'contacts',
  MIMOSA: 'mimosa',
  BUMAS: 'bumas',
  QLTS: 'qlts',
  Employee: 'employee',
};
